// extracted by mini-css-extract-plugin
export var linksList = "LfyoZ";
export var linksSeparator = "Lx5S-";
export var logo = "NayvD";
export var root = "XE+6d";
export var socialLinks = "qo8pT";
export var storeLinks = "QYqOW";